import { render, staticRenderFns } from "./_reportsTable.vue?vue&type=template&id=646c7623"
import script from "./_reportsTable.vue?vue&type=script&lang=js"
export * from "./_reportsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports